import {FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';

// form controls must follow naming: 'newPassword' and 'confirmPassword'
export function asyncPasswordValidator(): ValidatorFn {
    return (form: FormGroup): ValidationErrors | null => {
        return form.get('newPassword').value === form.get('confirmPassword').value ? null : {passwordsDoNotMatch: true};
    };
}
